import React from "react";
import Select from "react-select";

export const renderResRoomHotelEditableSelect = (
  prefix,
  prop,
  isEditable,
  onChangeMethod,
  optionsList,
  extraPropArray = [],
  cellInfo
) => {
  prefix = prefix.replace("$", cellInfo.index);
  if (isEditable) {
    return (
      <div>
        <Select
          value={
            optionsList.filter((d) => {
              return d.id === cellInfo.original[prop];
            })[0]
          }
          options={optionsList}
          clearable={false}
          getOptionLabel={(data) => {
            return data.name;
          }}
          getOptionValue={(data) => {
            return data.id;
          }}
          onChange={(value) => {
            // extraPropArray.push({ prop: prefix + prop + "_obj", value: value });
            extraPropArray.push({ prop: prefix + prop, value: value.id });
            extraPropArray.push({ prop: prefix + "edited", value: true });
            onChangeMethod(extraPropArray);
          }}
        />
      </div>
    );
  } else {
    return <div>{cellInfo.value}</div>;
  }
};
